import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const itemStyles = {
  primaryTypographyProps: {
    sx: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "24px",
    },
  },
};

const HeaderMenu = ({ anchorEl, open, onClose, items = [], userName, userEmail }) => {
  const handleItemClick = (item) => () => {
    if (item.onClick) {
      item.onClick();
    }
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            mt: -1,
            width: "250px",
            borderRadius: 1,
            boxShadow: 2,
          },
        },
      }}
    >
      <MenuList>
        {(userName || userEmail) && (
          <>
            <MenuItem
              disableRipple
              sx={{
                "&:hover": { backgroundColor: "transparent" },
                flexDirection: "column",
                alignItems: "flex-start",
                py: 1.5,
              }}
            >
              {userName && (
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#000000DE",
                    fontFamily: "Roboto, sans-serif",
                    letterSpacing: "0.15px",
                  }}
                >
                  {userName}
                </Typography>
              )}
              {userEmail && (
                <Typography
                  sx={{
                    fontFamily: "Roboto, sans-serif",
                    color: "#00000099",
                    fontWeight: 300,
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userEmail}
                </Typography>
              )}
            </MenuItem>
            <Divider />
          </>
        )}
        {items.map((item) => {
          const IconComponent = item.icon;
          if (item.path) {
            return (
              <MenuItem
                key={item.text}
                component={Link}
                to={item.path}
                onClick={onClose}
              >
                <ListItemIcon>
                  <IconComponent fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={item.text} {...itemStyles} />
              </MenuItem>
            );
          }
          return (
            <MenuItem key={item.text} onClick={handleItemClick(item)}>
              <ListItemIcon>
                <IconComponent fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={item.text} {...itemStyles} />
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};

export default HeaderMenu;
